import React, { useState } from "react"
import { Button, Drawer, List, Tag, Typography } from "antd"
import moment from "moment"

const RequestHistory = ({ record }) => {
  const [open, setOpen] = useState(false)

  // Function to check if there are valid admin requests
  const hasValidAdminRequests = () => {
    return (
      record.adminRequests &&
      record.adminRequests.some(
        (request) => request && request.requestDate && request.requestDate.seconds
      )
    )
  }

  const showDrawer = () => {
    setOpen(true)
  }

  const onClose = () => {
    setOpen(false)
  }

  const returnProperTag = (val) => {
    if (val === "admin") {
      return <Tag color="#1677ff">{val}</Tag>
    } else {
      return <Tag color="#13c2c2">{val}</Tag>
    }
  }

  return (
    <>
      <Button type="link" onClick={showDrawer} disabled={!hasValidAdminRequests()}>
        Show
      </Button>
      <Drawer
        title={`Product: ${record.product.productName}`}
        onClose={onClose}
        open={open}
        width={720}>
        <List
          dataSource={record.adminRequests}
          renderItem={(item) => (
            <List.Item key={item.requestDate ? item.requestDate.seconds : Math.random()}>
              <List.Item.Meta
                title={
                  <Typography.Text>
                    {returnProperTag(item.role)}
                    {`Requested By: ${item.requestedBy}`}
                  </Typography.Text>
                }
                description={`Comment: ${item.requestComment}`}
              />
              <div style={{ margineLeft: 5 }}>
                {item.requestDate
                  ? `Date: ${moment.unix(item.requestDate.seconds).format("DD/MM/YYYY HH:mm:ss")}`
                  : "No Date Available"}
              </div>
            </List.Item>
          )}
        />
      </Drawer>
    </>
  )
}

export default RequestHistory
